import {useMutation} from '@tanstack/react-query';
import api from "services/api";

const useDatasetUpdate = () => {
    const datasetUpdate = async (datasetId, req) => {
        try {
            const trials = await api.put(
                `api/v1/datasets/${datasetId}`,
                JSON.stringify(req),
                {
                    timeout: 10000,
                }
            );

            const data = await trials.json();

            return data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    };

    return useMutation(({req, datasetId}) => datasetUpdate(datasetId, req), {});
};

export default useDatasetUpdate;